import { render, staticRenderFns } from "./Owner.vue?vue&type=template&id=383d6559&scoped=true"
import script from "./Owner.vue?vue&type=script&lang=js"
export * from "./Owner.vue?vue&type=script&lang=js"
import style0 from "./Owner.vue?vue&type=style&index=0&id=383d6559&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383d6559",
  null
  
)

export default component.exports